import BaseApiRequest from "./BaseApiRequest";
import { GET_APPLICANT_LIST_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class GetApplicantListRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return GET_APPLICANT_LIST_URL;
  };

  getBody = () => {
    return this.body;
  };
}
